import { NgFor } from '@angular/common';
import { Component, inject } from '@angular/core';
import { ComponentsModule, DialogService, SnackBarService } from '@mastechnicaegroup/carelinelive-ui';
import { RunReportDialogComponent } from '../../../../dialogs/run/run-report-dialog.component';
import { catchError, of } from 'rxjs';

@Component({
    selector: 'app-reports-active-reports-tab',
    imports: [
        ComponentsModule,
        NgFor
    ],
    templateUrl: './reports-active-reports-tab.component.html',
    standalone: true,
    styleUrl: './reports-active-reports-tab.component.scss'
})
export class ReportsActiveReportsTabComponent {
    private readonly _dialog = inject(DialogService);
    private readonly _snackBar = inject(SnackBarService);

    testReportsData = [
        {
            id: 'package-summary',
            name: 'Package summary',
            description: 'Displays all packages.',
            last_requested: '',
        },
        {
            id: 'open-packages-summary',
            name: 'Open packages',
            description: 'Displays all currently open packages, including how long each has been open.',
            last_requested: '',
        },
        {
            id: 'package-responses',
            name: 'Package responses',
            description: 'Displays all responses to packages.',
            last_requested: '',
        },
        {
            id: 'received-rejected-package-responses',
            name: 'Received rejected package responses',
            description: 'Displays packages that were offered to providers and subsequently rejected.',
            last_requested: ''
        },
        {
            id: 'sent-rejected-package-responses',
            name: 'Sent rejected package responses',
            description: 'All packages that were rejected.',
            last_requested: ''
        },
        {
            id: 'time-taken-to-allocate-packages',
            name: 'Time taken to allocate packages',
            description: 'Displays all packages that were successfully allocated to a provider, along with the duration they were awaiting allocation.',
            last_requested: '',
        },
        {
            id: 'package-handbacks',
            name: 'Package handback',
            description: 'Displays all packages that were handed back.',
            last_requested: '',
        },
    ]

    runReport(report: string,) {
        return RunReportDialogComponent.show(this._dialog, report).closed.pipe(
            catchError(() => {
                this._snackBar.open({
                    colour: 'error',
                    dismissable: false,
                    icon: 'error_outline',
                    title: 'Failed to open report',
                    actions: [
                        { id: 'undo', label: 'OK' }
                    ]
                });
                return of(null);
            })
        ).subscribe();
    }
}
